var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('loading',{attrs:{"color":"#1989fa","vertical":""}},[_vm._v("正在登录...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }